import { useNavigate } from "react-router-dom";
import { useGame } from "./GameContext";

const HINTS = [
  { code: "suspect", txt: "용의자 프로파일" },
  { code: "code01", txt: "단서 조각 #1" },
  { code: "time02", txt: "단서 조각 #2" },
  { code: "time03", txt: "단서 조각 #3" },
  { code: "trace4", txt: "단서 조각 #4" },
  { code: "mind05", txt: "단서 조각 #5" },
  { code: "file06", txt: "단서 조각 #6" },
  { code: "lang07", txt: "단서 조각 #7" },
  { code: "alarm8", txt: "단서 조각 #8" },
  { code: "cross9", txt: "단서 조각 #9" },
];

export default function HintList() {
  const navigate = useNavigate();

  const { clearedStages, openHintDetail, openSuspectDetail } = useGame();

  return (
    <div className="hint_list storage_list_box_con con_box_storage con_box_storage01">
      <div className="box_con con_pd6">
        <p className="storage_tit mb8">단서 보관 상자</p>
        <p className="storage_txt mb40">단서를 모두 수집하세요.</p>

        <div className="storage_pBox">
          {HINTS.map((item, idx) => {
            const stageKey = item.code;
            const isUnlocked = clearedStages.has(stageKey);

            return (
              <a
                key={idx}
                className={`mb16 storage_ck storage_${idx + 1} ${
                  isUnlocked ? "sel" : ""
                }`}
                onClick={() => {
                  if (!isUnlocked) return;
                  if (stageKey === "suspect") {
                    openSuspectDetail();
                    return;
                  }
                  openHintDetail(stageKey);
                }}
              >
                {item.txt}
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}
